/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import {Subject} from "rxjs/Subject";
import {PropertyChangeEvent} from "./propertyChangedEvent";

export class ScriptSubscriber {
    id:string;
    scritpUnit: string;
    subject: Subject<PropertyChangeEvent>;
}